var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.number.hideSymbol)?_c('currency-symbol',{attrs:{"currency-context":_vm.$getAccount().currencyContext}}):_vm._e(),_c('span',[_vm._v(_vm._s(this.number.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }